__turbopack_context__.v({
  "ext": "IndexList-module-scss-module___iQeMq__ext",
  "isActive": "IndexList-module-scss-module___iQeMq__isActive",
  "list": "IndexList-module-scss-module___iQeMq__list",
  "name": "IndexList-module-scss-module___iQeMq__name",
  "preview": "IndexList-module-scss-module___iQeMq__preview",
  "previewImg": "IndexList-module-scss-module___iQeMq__previewImg",
  "previewInner": "IndexList-module-scss-module___iQeMq__previewInner",
  "previewSettle": "IndexList-module-scss-module___iQeMq__previewSettle",
  "previewWipeDown": "IndexList-module-scss-module___iQeMq__previewWipeDown",
  "previewWipeUp": "IndexList-module-scss-module___iQeMq__previewWipeUp",
  "row": "IndexList-module-scss-module___iQeMq__row",
  "strip": "IndexList-module-scss-module___iQeMq__strip",
  "stripImg": "IndexList-module-scss-module___iQeMq__stripImg",
  "type": "IndexList-module-scss-module___iQeMq__type",
  "year": "IndexList-module-scss-module___iQeMq__year",
});
